import React, { ReactElement } from 'react'
import { download } from '../../assets/images/images'
import PdfLink from '../PdfLink'

function LocativeText(): ReactElement {
  return (
    <>
      <p>L’attestation d’hébergement doit comporter :</p>
      <ul className="listUnstyled mb3 mb5md">
        <li>- Votre identité (nom, prénom, date et lieu de naissance)</li>
        <li>- L’identité et l’adresse de votre hébergeur</li>
      </ul>
      <PdfLink
        to="https://www.service-public.fr/simulateur/calcul/AttestationHebergement"
        title="Accéder au modèle d’attestation en ligne"
      />
      <div className="fontSizeXs dInlineFlex alignItemsCenter mb3 mb6md">
        <img src={download} alt="downloadAlert" className="mr1" />
        Veuillez vous assurer que ces informations sont cohérentes avec les
        justificatifs.
      </div>
    </>
  )
}

export default LocativeText
